// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1OvOe","list":"styles_list__1Nad4"};